<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать транзакцию
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'client-transaction-details', params: { transaction_id: transaction.id }}">← Назад к Деталям транзакции</router-link>
    </div>

    <div class="text-right">
      <a v-if="transaction.id" class="red" href="#" @click.prevent="deleteTransaction">удалить транзакцию</a>
    </div>

    <transaction-edit-form
      :transaction="transaction"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getTransaction, deleteTransaction } from '@/services/transaction.service'
import transactionEditForm from '@/components/forms/transaction/TransactionEditForm'

export default {
  name: 'transaction-edit',
  components: { transactionEditForm },
  data () {
    return {
      transaction: {
        id: null,
        amount: '',
        transaction_type: '',
        datetime: '',
        notation: '',
        client: ''
      },

      errors: {
        transaction: {
          id: [],
          amount: [],
          transaction_type: [],
          datetime: [],
          notation: [],
          client: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.transaction_id !== undefined) {
      this.transaction.id = this.$route.params.transaction_id

      getTransaction(this.transaction.id).then((response) => {
        this.transaction = response.data
      })
    }
  },
  methods: {
    deleteTransaction () {
      deleteTransaction(this.transaction.id).then((response) => {
        this.showMsg('Транзакция была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'client-details', params: { client_id: this.$route.params.client_id } })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Транзакция была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'client-details', params: { client_id: this.$route.params.client_id } })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// TransactionEdit.vue?aae0aa6e